import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, createTheme, ThemeProvider } from "@material-ui/core";

interface ConfirmDialogProps {
    open: boolean;
    setOpen: any;
    title: string;
    content: string;
    handleConfirm: any;
    confirmLabel?: string;
}

export default function ConfirmDialog({ open, setOpen, title, content, handleConfirm, confirmLabel }: ConfirmDialogProps) {
    const handleClose = () => {
        setOpen(false);
    };

    const dialogTheme = createTheme({
        palette: {
            primary: {
                main: '#005BAE',
            },
        },
        typography: {
            fontFamily: 'Roboto, Sarabun',
            fontSize: 14,
        },
        shape: {
            borderRadius: 8,
        },
    });

    return (
        <ThemeProvider theme={dialogTheme}>
            <Dialog open={open} onClose={handleClose} maxWidth="xs" aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus={true}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} color="secondary">
                        {confirmLabel || "Confirm"}
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}